<template>
  <div class="card-media-content">
    <slot />
  </div>
</template>

<script>
export default {
  name: "CardMediaContent"
};
</script>

<style lang="scss">
.card-media-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;

  display: flex;
  flex-wrap: wrap;
  min-width: 0;
}
</style>
